<template>
  <!--
    One tile in the summary card's TOTALS group (tablet/desktop only — mobile
    collapses the same four figures into stacked label/value rows in
    HeroSection). Every tile is the same shape; only the next-payment tile
    carries a date sub-label, the green value and the earnings links.
  -->
  <article
    class="flex flex-col gap-1.5 rounded-[14px] bg-primary-6 p-4 md:min-h-[108px] min-[1120px]:min-h-[126px] min-[1120px]:px-5 min-[1120px]:pb-4 min-[1120px]:pt-[18px]"
  >
    <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
      <span class="font-inter text-sm font-medium text-primary-1">{{ label }}</span>
      <span v-if="date" class="font-inter text-xs text-primary-1">({{ date }})</span>
      <InfoTooltip :label="label" :text="info" side="bottom" />
    </div>

    <p
      class="font-league text-2xl font-semibold leading-tight tracking-[-0.01em] min-[1120px]:text-[28px]"
      :class="accent ? 'text-green-400' : 'text-white'"
    >
      {{ value }}
    </p>

    <!-- Pinned to the tile floor so the links line up across the row. -->
    <div v-if="links" class="mt-auto flex flex-wrap items-center gap-x-2.5 gap-y-1 pt-2">
      <button
        type="button"
        class="font-inter text-xs font-normal text-primary-0 hover:text-secondary-5"
        @click="$emit('link-click', 'view-all-earnings')"
      >
        {{ PORTFOLIO_TERMS.viewAllEarnings }}
      </button>
      <span aria-hidden="true" class="font-inter text-xs text-primary-2">·</span>
      <button
        type="button"
        class="font-inter text-xs font-normal text-primary-0 hover:text-secondary-5"
        @click="$emit('link-click', 'view-breakdown')"
      >
        {{ PORTFOLIO_TERMS.viewBreakdown }}
      </button>
    </div>
  </article>
</template>

<script setup>
import { InfoTooltip } from "@/components";
import { PORTFOLIO_TERMS } from "@/constants/portfolioTerms";

defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
  // Copy behind the tile's info affordance.
  info: { type: String, required: true },
  // Rendered small and in parentheses after the label ("June 24").
  date: { type: String, default: "" },
  // Green figure instead of white — the next-payment tile only.
  accent: { type: Boolean, default: false },
  // Only the next-payment tile carries the two earnings links.
  links: { type: Boolean, default: false },
});

defineEmits(["link-click"]);
</script>
